module.exports = __webpack_public_path__ + "media/subscriber-logos/lendlease-da26bc80.png";